export default {
   primary:[
      'commercial',
      'industrial',
      'mixed use',
      'open space',
      'planned district',
      'residential',
      'government',
      'agriculture',
      'parking'
   ],
   secondary:{
      'residential':[
         'single family',
         'multi family'
      ],
      'commercial':[
         'office',
         'retail'
      ],
      'industrial':[
         'heavy manufacturing',
         'light manufacturing',
         'agricultural'
      ]
   }
}


// WEBPACK FOOTER //
// ./src/config/zoning-uses.js